module.exports = __webpack_public_path__ + "static/img/banner2.1adad6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/banner2.jpg
// module id = CKPc
// module chunks = 0